import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
export const FAQSection: React.FC = () => {
  const faqs = [{
    q: '¿Es realmente para todos los niveles o solo para principiantes?',
    a: 'El pack está diseñado específicamente para gimnasia infanto-juvenil con ejercicios progresivos que van desde nivel inicial hasta intermedio-avanzado. Cada ejercicio está clasificado por dificultad y aparato, así que funciona tanto si enseñás a principiantes como a gimnastas con experiencia.'
  }, {
    q: '¿Necesito conocimientos técnicos para usar las plantillas en Excel o Google Sheets?',
    a: 'Para nada. Las plantillas son súper intuitivas y fáciles de usar. Si sabés escribir en una celda de Excel, ya sabés usarlas. Además, vienen con instrucciones claras y están listas para rellenar con tu información. No necesitás fórmulas ni nada complicado.'
  }, {
    q: '¿Puedo adaptar los ejercicios a mi metodología de enseñanza?',
    a: '¡Absolutamente! Los ejercicios son una base sólida y probada, pero podés adaptarlos a tu estilo. De hecho, muchos profesores los usan como referencia y los combinan con sus propias variaciones. La idea es ahorrarte tiempo de investigación, no limitarte.'
  }, {
    q: 'Si no me sirve o no es lo que esperaba, ¿puedo pedir reembolso?',
    a: 'Sí, tenés 45 días de garantía total. Si por cualquier motivo decidís que el pack no es para vos, simplemente enviás un email y recibís el 100% de tu dinero de vuelta, sin preguntas incómodas. Asumimos todo el riesgo porque confiamos completamente en la calidad del material.'
  }, {
    q: '¿Recibo el material inmediatamente después de comprar?',
    a: '¡Sí! En cuanto completás tu compra, recibís un email con acceso instantáneo a todo el material. Podés descargarlo y empezar a usarlo en los próximos 5 minutos. No hay tiempos de espera ni envíos físicos.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const toggleFaq = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  return <section className="py-20 bg-gray-50" data-id="element-56">
      <div className="max-w-3xl mx-auto px-4" data-id="element-57">
        <div className="text-center mb-12" data-id="element-58">
          <h2 className="text-3xl md:text-4xl font-extrabold text-gray-900" data-id="element-59">
            Preguntas Frecuentes
          </h2>
        </div>

        <div className="space-y-4" data-id="element-60">
          {faqs.map((faq, index) => <div key={index} className="bg-white border border-gray-200 rounded-xl overflow-hidden shadow-sm" data-id="element-61">
              <button onClick={() => toggleFaq(index)} className="w-full px-6 py-5 text-left flex justify-between items-center focus:outline-none" data-id="element-62">
                <span className="font-bold text-gray-900 pr-4" data-id="element-63">{faq.q}</span>
                <ChevronDown className={`w-5 h-5 text-gray-500 transition-transform duration-300 flex-shrink-0 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-64" />
              </button>

              <AnimatePresence data-id="element-65">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3,
              ease: 'easeInOut'
            }} data-id="element-66">
                    <div className="px-6 pb-5 text-gray-600 leading-relaxed border-t border-gray-100 pt-4" data-id="element-67">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </section>;
};